import { useMatch } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  AdminReportLayout,
  ComingSoonPage,
  DataNotFoundPage,
  Drilldown,
} from 'eds-data-ux';

/**
 * The /data section for a user on the admin experience. Answering here rather
 * than in the report routes leaves no outlet, so a refusal covers the view.
 */
export function AdminDataSection() {
  const { dndShowAdminReport } = useFlags<{ dndShowAdminReport?: boolean }>();
  const isOverview = useMatch('/data/:productId/overview') !== null;
  const isOrgDrilldown =
    useMatch(`/data/:productId/overview/${Drilldown.Organization}`) !== null;
  const isTeacherDrilldown =
    useMatch(`/data/:productId/overview/${Drilldown.Teacher}`) !== null;
  const isClassDrilldown =
    useMatch(`/data/:productId/overview/${Drilldown.Class}`) !== null;
  const isStudentDrilldown =
    useMatch(`/data/:productId/overview/${Drilldown.Student}`) !== null;

  if (!dndShowAdminReport) return <ComingSoonPage />;
  // Every level of the Overview, down to one class. A level missing here is a
  // not-found even though its own route loader allowed it through.
  if (
    isOverview ||
    isOrgDrilldown ||
    isTeacherDrilldown ||
    isClassDrilldown ||
    isStudentDrilldown
  ) {
    return <AdminReportLayout />;
  }
  return <DataNotFoundPage />;
}
